export const PRD_DEPLOYMENT_DATE_FOR_SUMMARY_PANEL_CHANGES = new Date(2024, 1, 18);
